import React, { Fragment, useState } from 'react';
import Header3 from '../../components/header3/Header3';
import Scrollbar from '../../components/scrollbar/scrollbar'
import ProjectHero from '../../components/hero3/projecthero';
import BusinessContact from '../../components/business-consulting-components/BusinessContact/BusinessContact';
import BusinessFooter from '../../components/business-consulting-components/BusinessFooter/BusinessFooter';
import Video from '../../images/Video.png';
import ToolSection from '../../components/business-consulting-components/ToolSection';
import ClientNumber from '../../components/business-consulting-components/clientnumber';
import srj1 from '../../images/farmoduct1.png'
import srj2 from '../../images/srj2.svg'
import srj3 from '../../images/farmoduct3.png'
import srj4 from '../../images/farmoduct4.png'
import srj5 from '../../images/srj5.png'
import srj6 from '../../images/srj6.png'
import srj7 from '../../images/farmoduct7.png'
import srj8 from '../../images/srj8.png'
import srj9 from '../../images/srj9.png'
import srj10 from '../../images/farmoduct10.png'
import CaseStudiesSlider from '../../components/business-consulting-components/CaseStudiesSlider';


const Farmoduct = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
           <div className='index_business_consulting'>
                <main className="page_content s2">
                    <Header3 />
                    <ProjectHero top_title={<>Global Expansion & Export <br/> Lead Growth for Farmoduct <br/> (Agri Exports)</>}/>

                    <section className="video_section">
                        <div className="container text-center project_page_desp">
                            <h2>Company Overview</h2>

                            <ul className='project_page_ul'>
                                <li>
                                    <span className='number_css'>8+</span>
                                    <span className='hero_bottom_text'>Team Size</span>
                                </li>
                                <li>
                                    <span className='number_css'>India</span>
                                    <span className='hero_bottom_text'>Country</span>
                                </li>
                                <li>
                                    <span className='number_css'>B2B</span>
                                    <span className='hero_bottom_text'>Industry</span>
                                </li>
                                <li>
                                    <span className='number_css'>Organic Agricultural Products</span>
                                    <span className='hero_bottom_text'>Category</span>
                                </li>
                            </ul> 
                        </div>
                    </section>

                    <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>About Business</h2>
                                    <p className='heading_description text-dark mb-0'>
                                        Harshad is the owner of Farmoduct, an Indian <br/> exporter of organic agricultural products. With <br/> strong domestic trade relationships, the company <br/> set its sights on international expansion— <br/> prioritizing African markets and the GCC (UAE, <br/> Saudi Arabia)—where demand for high-quality, <br/> certified organic produce is growing rapidly.
                                    </p>
                                </div>

                                <div className="col-lg-6" style={{textAlign:'right'}}>
                                    <img src={srj1} alt="srj1" style={{maxWidth:'60%'}}/>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img src={srj2} alt="aiseo" className='img-fluid' style={{maxWidth:'60%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Client Challenges</h2>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Going global from India: Strong local business, but limited visibility for export-intent queries targeting GCC and Africa.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Organic positioning: Needed trust signals (certifications, traceability, quality systems) to win B2B buyers abroad.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>AI search gap: No presence in AI-driven platforms (Google AI Overviews/SGE, Bing Copilot, Perplexity).</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Lead quality over traffic: The mandate was qualified export RFQs (not just visits).</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space max_900 pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Overview</h2>
                                    <h3 className='mt-4'>SEO Brief</h3>
                                    <p className='heading_description text-dark mb-0'>During onboarding, Harshad shared that Farmoduct was starting digital marketing for the first time and needed a long-term partner to drive export visibility across Africa and the Gulf.</p>
                            
                                     <h3 className='mt-4'>Client Ask</h3>
                                      <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>How to rank in Google across GCC & African countries and get mentioned in AI platforms.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Which export keywords to prioritize for grains, mangoes, and millets to attract qualified buyers?</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>A detailed plan to scale SEO & marketing for international lead generation.</li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space max_900 pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <img src={srj3} alt="srj3" className='img-fluid' />
                                </div>
                                <div className="col-lg-12">
                                    <img src={srj4} alt="srj3" className='img-fluid' />
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <img src={srj7} alt="srj3" className='img-fluid' />
                                </div>
                            </div>
                        </div>
                    </section>
                    

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row challenges_css">
                                <div className="col-lg-6">
                                    <img src={srj8} alt="aiseo" className='img-fluid' style={{maxWidth:'70%',marginTop:'15%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Challenges We Faced</h2>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Crowded international SERPs with established regional suppliers.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Intent overlap between retail vs. B2B export terms (pricing, MOQ, packaging, grade).</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>New to AI answers—no structured Q&A, glossary, or schema to qualify for AI Overviews.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Need to balance India's presence with export priorities (GCC/Africa).</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space solution pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>Solution Provided</h2>
                                </div>

                                <div className="col-lg-6">
                                    <ul class="srj_list solution_list mt-4">
                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Diagnosis & Audit</div>
                                                <p>Full technical SEO audit (indexation, canonicals, thin/duplicate templates) plus an export-intent keyword audit to isolate B2B from retail traffic.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Content & Export Authority Strategy</div>
                                                <p>Pillar–cluster model around export categories: Grains, Millets, Fresh Mangoes, Processing & Packaging, Quality & Certifications, Logistics & Shipping.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>AI SEO (Answer Engine Optimization & Generative Engine Optimization)</div>
                                                <p>Optimized FAQs and structured Q&A content for agricultural products-related queries and added schema markup (Product, Organization, FAQ, Review) to improve AI parsing.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>On-Page & Internal Linking</div>
                                                <p>Entity-rich copy mapped to buyer intent (spec sheets, grades, moisture %, residue limits). Modular CTAs: Request COA, Get Packing Options, Get CIF Quote.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>CRO & Lead Quality Uplift</div>
                                                <p>We have done the conversion rate optimization by optimizing the landing pages and forms with qualification gates (commodity, grade, monthly volume, destination port, target INCO terms, certifications required).</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Backlink & PR (Trade & Govt Ecosystem)</div>
                                                <p>Export directories & trade portals, APEDA listings, chamber associations, and buyers’ guides in regional agri publications to build prominence and referral demand.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Analytics & Ops</div>
                                                <p>We made sure we track everything so that we can avoid the guesswork. For this, we were tracking website UX and user journey, website engagement using heatmaps, Google SERP keyword tracking, and AI Brand mention tracking, etc.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Regional Keyword Plan</div>
                                                <p>We have mapped the target products and their keywords with the local searches so that we can map the user intent.</p>
                                            </div>
                                        </li>


                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <ToolSection title1={<>Want to expand your export business globally? </>} title2={<>Let us build your AI SEO and export-focused strategy.</>} />
                    
                    <section className="intro_about_section section_space project_outcome max_900 pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Outcome</h2>
                                </div>

                                <div className="col-lg-10 offset-lg-2">
                                    <ul class="srj_list solution_list mt-4">

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Increased Organic Visibility</div>
                                                <p>Increased Organic Visibility for export clusters (millets, grains, mangoes) in GCC & Africa.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Increased Qualified Leads</div>
                                                <p>Qualified RFQs: First wave of UAE & KSA enquiries plus early traction in East/West Africa.</p>
                                            </div>
                                        </li>

                                         <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Brand Visibility in AI Platforms</div>
                                                <p>Early visibility in AI-driven answer engines for target keywords.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Good Backlink Profile</div>
                                                <p>Authority Lift via trade/association backlinks and compliance-led content.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Steady Lead Flow</div>
                                                <p>Steady Pipeline as seasonal mango demand complements year-round grains/millets.</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>                            
                        </div>
                    </section>
                    <ClientNumber/>

                    <section className="intro_about_section section_space project_outcome">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <img src={srj10} alt="srj10" className='img-fluid' />
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container max_900">
                            <div className="row">
                                <div className="col-lg-12 text-center tool_section_new">
                                    <h2>Partner with us and get your custom AI SEO <br/> strategy for your business</h2>
                                    <button className="read_more btn btn-secondary">Contact Now</button>
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <CaseStudiesSlider/>
                    <BusinessContact />
                    <BusinessFooter />
                    <Scrollbar />
                </main>
            </div>
        </Fragment>
    )
};
export default Farmoduct;
